import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VendorService } from '../proxy/controlling/controllers/vendor.service';
import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';

FieldBuilder.setNamespace('Controlling');

export const VENDORCONTRACTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey(
    'vendorId',
    'Entity.Vendor',
    VendorService
  )
    .required()
    .displayFromNested('vendor.fantasyName')
    .sortBy('vendor.fantasyName')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey(
    'contractTypeId',
    'Entity.ContractType',
    ContractTypeService
  )
    .required()
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .build(),
];

export const VENDORCONTRACTTYPE_CONFIG = {
  entityName: 'VendorContractType',
  localizationKey: 'Controlling::Entity.VendorContractType',
  fields: VENDORCONTRACTTYPE_FIELDS,
  permission: 'ControllingContract.VendorContractTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
